import { PageSections, usePublicPage } from '@/features/public-pages';
import { LEGAL_COMMAND_CENTER_PAGE_SLUG, LEGAL_COMMAND_CENTER_SECTION_KEYS } from '../constants';

/**
 * The Due Diligence page's legal-services sections under the Legal Command
 * Center's top panel (MYN-331, FR-300), in that page's order, with its live
 * Issue Report price. Nothing renders while loading or when the page cannot
 * be read: the top panel above is the part the user came for.
 */
export function LegalCommandCenterSections() {
  const page = usePublicPage(LEGAL_COMMAND_CENTER_PAGE_SLUG);
  if (!page.data) return null;
  const sections = page.data.sections.filter((section) =>
    LEGAL_COMMAND_CENTER_SECTION_KEYS.includes(section.key),
  );
  if (sections.length === 0) return null;
  return <PageSections sections={sections} pageSlug={LEGAL_COMMAND_CENTER_PAGE_SLUG} />;
}
